/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ portal: NonNullable<unknown>, level: NonNullable<unknown> }} Portals_Matrix_HintInputs */

const cs_portals_matrix_hint = /** @type {(inputs: Portals_Matrix_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.portal}: ${i?.level}`)
};

const en_portals_matrix_hint = /** @type {(inputs: Portals_Matrix_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.portal}: ${i?.level}`)
};

/**
* | output |
* | --- |
* | "{portal}: {level}" |
*
* @param {Portals_Matrix_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_matrix_hint = /** @type {((inputs: Portals_Matrix_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Matrix_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_matrix_hint(inputs)
	return cs_portals_matrix_hint(inputs)
});